import Coming from 'pages/public/Coming/Coming'
import React, { Component } from 'react'

export default class Forgot extends Component {
  render() {
    return (
      <div>
        <Coming/>
      </div>
    )
  }
}
